// removed by extract-text-webpack-plugin
module.exports = {"Content":"purify_Content__Content___3zXlB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/Content.scss
// module id = 178
// module chunks = 0